import React, { useState, useEffect } from "react"
import Layout from "../components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import ListActualites from "../components/Home/Actualites/actualites"
import ContenuLibre from "../components/ContenuLibre/contenu-libre"
import CarnetAdresse from "../components/Home/CarnetAdresse/carnet-adresse"
import AgendaEvenements from "../components/Home/Agenda/agenda"
import ListNePasManquer from "../components/Home/NePasManquer/ne-pas-manquer"
import ListPartenaires from "../components/Home/Partenaires/partenaires"
import AccesDirects from "../components/Home/AccesDirect/acces-direct"
import {
  sectionFirst,
  sectionFirstResponsive,
  sectionSecond,
  sectionSecondResponsive,
  sectionThird,
  sectionThirdResponsive,
  container,
  responsiveList,
  responsiveListItem,
  responsiveListItemSelected,
} from "../styles/index.module.scss"
import root from "window-or-global"
import PropTypes from "prop-types"
import { windowWidth } from "../constants"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import styled from "styled-components"
import NotificationPopup from "gatsby-theme-blank/src/components/NotificationPopup/notification-popup"
import BandeauAlert from "../components/BandeauAlert/bandeau-alert"

//-----------------------Parent Component---------------------------//
const IndexPage = ({ location }) => {
  const buildColors = useBuildData().theme_settings.palette
  const buildInfos = useBuildData().site_settings
  const [responsiveSection, setResponsiveSection] = useState("À la une")
  const tabSection = ["À noter", "À la une", "Plus d'infos"]
  const [dimensions, setDimensions] = useState({
    height: root.innerHeight,
    width: root.innerWidth,
  })
  useEffect(() => {
    const debouncedHandleResize = debounce(() => {
      setDimensions({
        height: root.innerHeight,
        width: root.innerWidth,
      })
    }, 1)

    root.addEventListener("resize", debouncedHandleResize)

    return (_element) => {
      root.removeEventListener("resize", debouncedHandleResize)
    }
  })
  return (
    <Layout isIndex={true}>
      <SEO
        description={buildInfos.seo.description_tag}
        title={buildInfos.seo.title_tag || "Accueil"}
      />
      <ul className={responsiveList}>
        {tabSection.map((sectionName) => {
          return (
            <ResponsiveListItem
              textColor={buildColors.d_color_gradients.d_dark}
              borderColor={buildColors.a_color_gradients.a_dark}
              key={sectionName}
              role="presentation"
              onClick={() => setResponsiveSection(sectionName)}
              onKeyDown={() => setResponsiveSection(sectionName)}
              className={
                responsiveSection === sectionName
                  ? responsiveListItemSelected
                  : responsiveListItem
              }
            >
              {sectionName}
            </ResponsiveListItem>
          )
        })}
      </ul>
      <IndexLayout
        location={location}
        buildInfos={buildInfos}
        colors={buildColors}
        dimensions={dimensions}
        responsiveSection={responsiveSection}
      />
    </Layout>
  )
}
//-----------------------Parent Component---------------------------//

//-----------------------Child Component---------------------------//

const IndexLayout = ({
  location,
  responsiveSection,
  dimensions,
  colors,
  buildInfos,
}) => {
  if (dimensions.width > windowWidth) {
    responsiveSection = "À la une"
  }
  return (
    <>
      <ColoredSection
        bgColor={colors.a_color_gradients.a_light}
        className={
          responsiveSection === "À noter" && dimensions.width < windowWidth
            ? sectionFirstResponsive
            : sectionFirst
        }
      >
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_1" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_3" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_5" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_7" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_9" />
        </article>
      </ColoredSection>
      <section
        className={
          responsiveSection === "À la une"
            ? sectionSecondResponsive
            : sectionSecond
        }
      >
        <BandeauAlert alertContent={buildInfos.alert_message.value} />
        <NotificationPopup
          popupContent={buildInfos.notification_popup.value}
          location={location}
        />
        <section className={container}>
          <ListActualites />
        </section>
        <section className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_A" />
        </section>
        <section className={container}>
          <AccesDirects />
        </section>
        <section className={container}>
          <AgendaEvenements />
        </section>
        <section className={container}>
          <CarnetAdresse />
        </section>
        <section className={container}>
          <ListNePasManquer />
        </section>
        <section className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_B" />
        </section>
        <section className={container}>
          <ListPartenaires />
        </section>
      </section>
      <ColoredSection
        bgColor={colors.a_color_gradients.a_light}
        className={
          responsiveSection === "Plus d'infos" && dimensions.width < windowWidth
            ? sectionThirdResponsive
            : sectionThird
        }
      >
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_2" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_4" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_6" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_8" />
        </article>
        <article className={container}>
          <ContenuLibre isIndex={true} zoneTaxoLibre="zone_accueil_10" />
        </article>
      </ColoredSection>
    </>
  )
}
//-----------------------Child Component---------------------------//

//-----------------------Function for IndexPage---------------------------//

function debounce(fn, ms) {
  let timer
  return (element) => {
    clearTimeout(timer)
    timer = setTimeout((_element) => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  }
}
//-----------------------Function for IndexPage---------------------------//

//-----------------------Styled component---------------------------//

const ColoredSection = styled.section`
  background-color: ${(props) => props.bgColor};
`
const ResponsiveListItem = styled.li`
  color: ${(props) =>
    props.className === responsiveListItemSelected ? props.textColor : null};
  border-bottom: 6px solid
    ${(props) =>
      props.className === responsiveListItemSelected
        ? props.borderColor
        : null};
`
//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

IndexPage.propTypes = {
  location: PropTypes.object,
}

IndexLayout.propTypes = {
  location: PropTypes.object,
  responsiveSection: PropTypes.string,
  dimensions: PropTypes.object,
  colors: PropTypes.object,
  buildInfos: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default IndexPage
